<div class="document-form-container" [attr.data-test-id]="'wrap-' + fieldAttribute.backendAttribute.name">
  <app-file-form-field
    [inputContainerStyle]="'form-control'"
    [attribute]="fieldAttribute"
    [group]="form"
    [valid]="isFieldInvalid()"
    (fileUpdated)="updateFile($event)"
    (onError)="onError()"
  ></app-file-form-field>
  <button
    class="btn btn-outline-primary delete-document-btn"
    type="button"
    [attr.data-test-id]="'delete-document-btn-' + fieldAttribute.backendAttribute.name"
    *ngIf="fileLink"
    (click)="delete()"
  >
    {{ (fieldAttribute.multiple ? 'FIELD_DELETE_FILES_HINT' : 'FIELD_DELETE_DOCUMENT_HINT') | translate }}
  </button>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
